export default {
  CLIENT_ID: "d00bdb1af84c4faef82c",
  CLIENT_SECRET: "1875475451faf4c8bc1fdc69033fb4da6441d145",
  REDIRECT_URL:
    "https://test-functions.cloudflare-functions-oauth-example.pages.dev/",
  AUTHORIZATION_ENDPOINT: "https://github.com/login/oauth/authorize",
  TOKEN_ENDPOINT: "https://github.com/login/oauth/access_token",
  RESOURCE_ENDPOINT: "https://api.github.com/",
};
